import React from 'react';
import sharkKidLogoDark from '../assets/shark_kid_logo_light.png'; // Use the dark logo for the header
import CoinDropCountdown from './Counter';
import { getAnalytics, logEvent } from 'firebase/analytics';

const Header = ({handleNavClick}) => {
  return (
    <header style={{
      backgroundColor: '#2d3748',
      padding: '0',
      borderBottom: '1px solid #4a5568',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingLeft: '1rem',
      paddingRight: '1rem'
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <img src={sharkKidLogoDark} alt="SharkKid Logo" style={{ height: '50px', borderRadius: '8px', opacity: '1', marginRight: '10px' }} />
        <h1 style={{ margin: 0, fontSize: '1.8rem', color: '#63b3ed' }}>SharkKid</h1>
      </div>
        <CoinDropCountdown />
      <nav>
        <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex' }}>
          <li style={{ marginLeft: '1.5rem' }}><a href="#about" onClick={handleNavClick('About')} style={{ color: '#edf2f7', textDecoration: 'none', fontWeight: 'bold' }}>About</a></li>
          <li style={{ marginLeft: '1.5rem' }}><a href="#roadmap" onClick={handleNavClick('Roadmap')} style={{ color: '#edf2f7', textDecoration: 'none', fontWeight: 'bold' }}>Roadmap</a></li>
          <li style={{ marginLeft: '1.5rem' }}><a href="#community" onClick={handleNavClick('Community')} style={{ color: '#edf2f7', textDecoration: 'none', fontWeight: 'bold' }}>Community</a></li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;